(function () {
    'use strict';

    angular
        .module('app.eventDisplay')
        .factory('eventDisplayService', eventDisplayService);

    eventDisplayService.$inject = ['common'];
    /* @ngInject */
    function eventDisplayService(common) {
        var service = {
            pictureBoxStyle: pictureBoxStyle,
            getPictureBoxContent: getPictureBoxContent
        };

        return service;

        function pictureBoxStyle() {

            var result = {};
            if (vm.item.PictureBackgroundImage.Base64Data) {
                result["background"] = "url(data:image/png;base64," + vm.item.PictureBackgroundImage.Base64Data + ")";
                if (vm.item.RepeatPictureBackgroundImage == 0) {
                    result["background"] += "no-repeat";
                }
            }
            else {
                result["background-color"] = vm.item.PicutreBoxBackgroundColor;
            }


            return result;
        }

        function getPictureBoxContent(contentLocation) {
            var result = "";

            if (contentLocation === 'Top') {
                result = vm.item.InprogressTopContent;
            }
            else {
                result = vm.item.InprogressBottomContent;
            }

            if (!result) {
                result = "";
            }

            result = result.replace('%DateTime%', moment(vm.currentDate).format("LL") + "<br />" + moment(vm.currentDate).format("LTS"));
            result = result.replace('%Date%', moment(vm.currentDate).format("LL"));
            result = result.replace('%Time%', moment(vm.currentDate).format("LTS"));

            result = result.replace('%RoomName%', "");


            return result;


        }
      
    }
})();
